var render = function render(){var _vm=this,_c=_vm._self._c;return _c('loading',{attrs:{"text":_vm.text},model:{value:(_vm.showLoading),callback:function ($$v) {_vm.showLoading=$$v},expression:"showLoading"}})
}
var staticRenderFns = []

export { render, staticRenderFns }